import styled from 'styled-components';
import { Field } from 'formik';

import { rem, themed } from '@/shared/ui/core';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  span {
    align-self: flex-end !important;
    color: ${themed('primary.textGray')} !important;
    font-size: 0.725rem !important;
    margin-top: 0.125rem !important;
  }
`;

export const TextareaStyled = styled(Field)`
  font-size: ${rem(14)};
  line-height: 1.5;
  width: 100%;
  height: ${rem(130)};
  padding: 1rem;
  border: 1px solid ${themed('primary.gray')};
  border-radius: ${rem(5)};
  outline: none;
  resize: none;
  ::placeholder {
    color: ${themed('primary.darkGray')};
  }
`;
